export default "__VITE_PUBLIC_ASSET__87718874__"